import React from 'react';

const Footer = () => {
  return (
      <footer className="footer">
        <div className="footer-copyright">UNIGINE © 2005-{new Date().getFullYear()}. All rights reserved.</div>
      </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js